<template>
    <section class="chart-container">
        <el-row>
            <!-- <el-col :span="24">
                <span>总用户数： </span>
            </el-col>
            <el-col :span="24">
                <span>总作品数： </span>
            </el-col> -->
                <div id="chartColumn" style="width: 400px; height:300px;"></div>
            <!-- <el-col :span="12">
                <div id="chartBar" style="width:100%; height:400px;"></div>
            </el-col>
            <el-col :span="12">
                <div id="chartLine" style="width:100%; height:400px;"></div>
            </el-col>
            <el-col :span="12">
                <div id="chartPie" style="width:100%; height:400px;"></div>
            </el-col> -->
            <el-col :span="12">
                <div class="title"> 
                    <span>作品排行榜</span>
                    <span @click='goWorks'>更多></span>
                </div>
                <el-table :data="tableData" height="530" border style="width: 100%">
                    <el-table-column type="index" label="名次" width="50">
                    </el-table-column>
                    <el-table-column prop="title" label="日期" max-width="120">
                    </el-table-column>
                    <el-table-column prop="author" label="姓名" width="100">
                    </el-table-column>
                    <el-table-column prop="open" label="浏览(次)" width="80">
                    </el-table-column>
                    <el-table-column prop="share" label="转发(次)" width="80">
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :span="12">
                <div class="title"> 
                    <span>用户排行榜</span>
                    <span @click='goUsers'>更多></span>
                </div>
                <el-table :data="tableData1" height="530" border style="width: 100%">
                    <el-table-column type="index" label="名次" width="50">
                    </el-table-column>
                    <el-table-column prop="nickName" label="用户" max-width="180">
                    </el-table-column>
                    <el-table-column prop="sales" label="总营销金额(元)">
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
       
    </section>
</template>

<script>
    import echarts from 'echarts'
    export default {
        watch: {
            totalUserNumber(val) {
              //  if(this.totalWorkNumber) {
                    this.drawColumnChart()
              //  }
            },
            totalWorkNumber(val) {
               // if(this.totalUserNumber) {
                    this.drawColumnChart()
              //  }
            },
        },
        data() {
            return {
                chartColumn: null,
                chartBar: null,
                chartLine: null,
                chartPie: null,
                tableData: null,
                tableData1: [],
                totalUserNumber: null,
                totalWorkNumber: null,
            };
        },
        methods: {
            goWorks() {
                this.$router.push({path:'/works'})
            },
            goUsers() {
                this.$router.push({path:'/users'})
            },
            formatDatas(item) {
				return {
					title: item.title,
					author: item.owner&&item.owner.nickName || item.owner.username,
					open: item.statistics&&item.statistics.open,
					share: item.statistics&&item.statistics.share,
				};
            },
            formatUsers(item) {
				return {
					id: item.id,
					nickName: item.nickName||item.username,
					sales: item.sales
				};
			},
            async getWorks() {
                let query = { pageIndex: 0, pageSize: 10 };
					query['sort'] =  'statistics.open:DESC';
				let result = await this.$http.post(this,'/project',query);
				if (result && result.code == 200) {
					this.tableData = result.data.data.map((item) => { return this.formatDatas(item) });
                }
            },
            async getUsers() {
				let result = await this.$http.get(this,'/statistics/user/sales/top');
				if (result && result.code == 200) {
					this.tableData1 = result.data.map((item) => { return this.formatUsers(item) });
                }
            },
            async getUserNO() {
				let result = await this.$http.get(this,'/user/count');
				if (result && result.code == 200) {
					this.totalUserNumber = result.data;
                }
            },
            async getWorkNO() {
				let result = await this.$http.get(this,'/project/count');
				if (result && result.code == 200) {
					this.totalWorkNumber = result.data;
                }
			},
            drawColumnChart() {
                console.log('----draw',this.totalUserNumber, this.totalWorkNumber)
                this.chartColumn = echarts.init(document.getElementById('chartColumn'));
                this.chartColumn.setOption({
                  title: { text: '用户/作品统计' },
                  tooltip: {},
                  xAxis: {
                      data: ["总用户数", "总作品数"]
                  },
                  yAxis: {},
                  series: [{
                      name: '销量',
                      type: 'bar',
                      data: [this.totalUserNumber, this.totalWorkNumber]
                    }]
                });
            },
            drawBarChart() {
                this.chartBar = echarts.init(document.getElementById('chartBar'));
                this.chartBar.setOption({
                    title: {
                        text: 'Bar Chart',
                        subtext: '数据来自网络'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {
                        data: ['2011年', '2012年']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01]
                    },
                    yAxis: {
                        type: 'category',
                        data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
                    },
                    series: [
                        {
                            name: '2011年',
                            type: 'bar',
                            data: [18203, 23489, 29034, 104970, 131744, 630230]
                        },
                        {
                            name: '2012年',
                            type: 'bar',
                            data: [19325, 23438, 31000, 121594, 134141, 681807]
                        }
                    ]
                });
            },
            drawLineChart() {
                this.chartLine = echarts.init(document.getElementById('chartLine'));
                this.chartLine.setOption({
                    title: {
                        text: 'Line Chart'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['邮件营销', '联盟广告', '搜索引擎']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '邮件营销',
                            type: 'line',
                            stack: '总量',
                            data: [120, 132, 101, 134, 90, 230, 210]
                        },
                        {
                            name: '联盟广告',
                            type: 'line',
                            stack: '总量',
                            data: [220, 182, 191, 234, 290, 330, 310]
                        },
                        {
                            name: '搜索引擎',
                            type: 'line',
                            stack: '总量',
                            data: [820, 932, 901, 934, 1290, 1330, 1320]
                        }
                    ]
                });
            },
            drawPieChart() {
                this.chartPie = echarts.init(document.getElementById('chartPie'));
                this.chartPie.setOption({
                    title: {
                        text: 'Pie Chart',
                        subtext: '纯属虚构',
                        x: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                    },
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '60%'],
                            data: [
                                { value: 335, name: '直接访问' },
                                { value: 310, name: '邮件营销' },
                                { value: 234, name: '联盟广告' },
                                { value: 135, name: '视频广告' },
                                { value: 1548, name: '搜索引擎' }
                            ],
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                });
            },
            drawCharts() {
                this.drawColumnChart()
                this.drawBarChart()
                this.drawLineChart()
                this.drawPieChart()
            },
        },

        mounted: function () {
            // this.drawCharts();
            this.getWorks();
            this.getUsers();
            this.drawColumnChart();
            this.getUserNO();
            this.getWorkNO();

        },
        updated: function () {
           // this.drawColumnChart()
           // this.drawCharts()
        }
    }
</script>

<style scoped>
    .chart-container {
        width: 100%;
        float: left;
    }
    /*.chart div {
        height: 400px;
        float: left;
    }*/

    .el-col {
        padding: 30px 20px;
    }

    .title {
        font-weight: 500;
        padding: 0 16px 16px 0;
        display: flex;
        justify-content: space-between;
    }
    .title span:last-child {
        cursor: pointer;
        font-size: 12px;
        font-weight: bold;
    }
</style>
